import { getLocalizedName } from "common/index";
import { RecordListSummary } from "common/record/form/content/audit-trail/record-list-summary";
import type { Context } from "common/types/context";
import type { ScheduledWorkOrderRecalculatedEvent } from "common/types/events";
import {
  ColumnTypes,
  type EntityColumn,
} from "common/entities/entity-column/types";
import { Row } from "../row";
import { EmptyDetails } from "./empty";
import { ScheduledWorkOrderRecalculatedReasonDetails } from "./reason/scheduled-work-order-recalculated-reason";

interface PropTypes {
  event: ScheduledWorkOrderRecalculatedEvent;
  context: Context;
  hideLinks?: boolean;
}

const getFakeWoColumn = (entity: string): EntityColumn => ({
  name: "workOrderId,",
  dataType: "fk",
  columnType: ColumnTypes.Custom,
  isForeignKey: true,
  relatedEntity: entity,
  relatedColumn: "id",
});

export const ScheduledWorkOrderRecalculated = ({
  event,
  context,
  hideLinks,
}: PropTypes) => {
  const { entityName, countOfVoidedWorkOrder, voidedWorkOrderIds } =
    event.details ?? {};
  const isFeatureEnabled = context.isEnabledFeature("preserveFutures");
  const actionLabel = isFeatureEnabled ? _("Voided") : _("Deleted");
  const woEntityName =
    getLocalizedName(context.entities[entityName]) ?? _("Work Orders");

  return (
    <>
      <EmptyDetails event={event} uiFormat={context.uiFormat} />
      <Row
        label={_("Count of {ENTITY} {ACTION}")
          .replace("{ACTION}", actionLabel)
          .replace("{ENTITY}", woEntityName)}
      >
        {countOfVoidedWorkOrder}
      </Row>
      {countOfVoidedWorkOrder ? (
        <Row
          label={_("List of {ENTITY} {ACTION}")
            .replace("{ACTION}", actionLabel)
            .replace("{ENTITY}", woEntityName)}
        >
          <RecordListSummary
            context={context}
            entityName={entityName}
            title={_("{ACTION} {ENTITY}")
              .replace("{ACTION}", actionLabel)
              .replace("{ENTITY}", woEntityName)}
            recordIds={voidedWorkOrderIds}
            recordsCount={countOfVoidedWorkOrder}
            entityColumn={getFakeWoColumn(entityName)}
            hideLinks={hideLinks || !isFeatureEnabled}
          />
        </Row>
      ) : undefined}

      <ScheduledWorkOrderRecalculatedReasonDetails
        context={context}
        reason={event.details.reason}
      />
    </>
  );
};

ScheduledWorkOrderRecalculated.displayName = "ScheduledWorkOrderRecalculated";
